import type { SxProps, Theme } from '@mui/material';

export const spreadSelectorFormControlSx: SxProps<Theme> = {
  minWidth: { xs: '100%', sm: 280 },
};
